package com.yogaaicoach.pages.auth

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.yogaaicoach.common.network.KeyEventApi
import com.yogaaicoach.pages.auth.firebase.platformSignInWithFacebook
import com.yogaaicoach.pages.auth.firebase.platformSignInWithGoogle
import com.yogaaicoach.user.UserInfo
import kotlinx.coroutines.launch

/**
 * Holds the sign-in logic shared by every LoginScreen renderer (Compose and React). Split out of
 * LoginScreenViewModel because that class also carries Compose-only UI state (background image
 * resource, fade transition) that has no React equivalent.
 */
class LoginActionsViewModel(private val keyEventApi: KeyEventApi) : ViewModel() {

    fun signInWithGoogle(onLoginSuccess: (UserInfo) -> Unit) {
        viewModelScope.launch { keyEventApi.logKeyEvent("sign_in_google") }
        viewModelScope.launch {
            val userInfo = platformSignInWithGoogle()
            if (userInfo != null) {
                onLoginSuccess(userInfo)
            }
            // TODO handle failed login case??
        }
    }

    fun signInWithFacebook(onLoginSuccess: (UserInfo) -> Unit) {
        viewModelScope.launch { keyEventApi.logKeyEvent("sign_in_facebook") }
        viewModelScope.launch {
            val userInfo = platformSignInWithFacebook()
            if (userInfo != null) {
                onLoginSuccess(userInfo)
            }
            // TODO handle failed login case??
        }
    }

    fun logEmailSignInClicked() {
        viewModelScope.launch { keyEventApi.logKeyEvent("sign_in_email") }
    }
}
